(() => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const slowConnection = connection && /(^|-)2g$/.test(connection.effectiveType || '');
  if (connection?.saveData || slowConnection) return;

  const seen = new Set();
  let armed = false;

  const isEligible = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement)) return false;
    if (!anchor.href || anchor.target === '_blank' || anchor.hasAttribute('download')) return false;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin) return false;
    if (url.href === location.href) return false;
    if (url.hash && url.pathname === location.pathname && url.search === location.search) return false;
    if (/^\/(account|challenge)(\/|$)/.test(url.pathname)) return false;
    return true;
  };

  const prefetch = (anchor) => {
    if (!armed || !isEligible(anchor)) return;
    const url = new URL(anchor.href, location.href);
    const key = url.pathname + url.search;
    if (seen.has(key)) return;
    seen.add(key);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url.href;
    link.as = 'document';
    document.head.appendChild(link);
  };

  const findAnchor = (event) => event.target instanceof Element ? event.target.closest('a[href]') : null;
  const arm = () => { armed = true; };

  window.addEventListener('load', () => {
    if ('requestIdleCallback' in window) requestIdleCallback(arm, { timeout: 1500 });
    else setTimeout(arm, 750);
  }, { once: true });

  document.addEventListener('pointerenter', (event) => prefetch(findAnchor(event)), true);
  document.addEventListener('focusin', (event) => prefetch(findAnchor(event)), true);
  document.addEventListener('touchstart', (event) => prefetch(findAnchor(event)), { passive: true, capture: true });
})();
